import { Tabs } from "antd";

export function createTab(label, children, key) {
  if (!key) key = label;
  return { label, children, key };
}

export const TabView = ({ items }) => <Tabs items={items} />;
